export default __webpack_public_path__ + "static/media/deco-img(3).745145f0.png";